import type { FC } from 'react'
import { VERSION } from '@/constants'
import { useIsTeams } from '@/hooks/useIsTeams'

const linkCn = 'font-medium text-gray-600 hover:text-primary mx-3'

export const Footer: FC<{}> = () => {
  const currentYear = new Date().getFullYear()
  const isInTeams = useIsTeams()

  return (
    <footer className="bg-gray-100 w-full py-5 px-4">
      <div className="flex flex-wrap items-center justify-between">
        <div className="flex flex-wrap items-center">
          <span className="text-sm text-gray-600 mx-3">
            © {currentYear} Appfluence Inc
          </span>

          {!isInTeams && (
            <>
              <a
                className={linkCn}
                href="https://prioritymatrix.com/?utm_campaign=delayed-send"
                target="_blank"
                rel="noreferrer"
              >
                Priority Matrix
              </a>

              <a
                className={linkCn}
                href="https://teamsreminder.com/?utm_campaign=delayed-send"
                target="_blank"
                rel="noreferrer"
              >
                My Reminders
              </a>

              <a className={linkCn} href="/pricing">
                Pricing
              </a>

              <a className={linkCn} href="/help">
                Help
              </a>

              <a className={linkCn} href="/articles">
                Articles
              </a>

              <a className={linkCn} href="/eula">
                Terms
              </a>

              <a className={linkCn} href="/privacy">
                Privacy
              </a>

              <a className={linkCn} href="/contact-us">
                Contact Us
              </a>
            </>
          )}
        </div>

        {!isInTeams && (
          <span className="text-xs text-gray-500 mx-3 mt-2 md:mt-0">
            Version {VERSION}
          </span>
        )}
      </div>
    </footer>
  )
}